'use strict';

export default angular
  .module('maestro.services.data.files', [
    'maestro.services.webcore'
  ])
  .service('FilesService', FilesService)
  .name;

function FilesService(webcore, $q) {

  /**
   * Returns a list of application files filtered by query parameters.
   * See {@link https://iotapps.docs.apiary.io/#reference/application-files/files-management/get-files}
   *
   * API_KEY: Optional to get publicly available files.
   *
   * @param params Request parameters.
   * @param {number} [params.fileId] File ID to filter by.
   * @param {number} [params.type] Type of the file to filter by. Types of file:
   *     - 1 - user image
   *     - 2 - location image
   *     - 3 - device image
   *     - 4 - bitmap mask
   *     - 5 - any
   * @param {number} [params.userId] User ID associated with this file. It can be used by adminis to access other user accounts.
   * @param {number} [params.locationId] ID of the location associated with the file to filter by.
   * @param {string} [params.deviceId] ID of the device associated with the file to filter by.
   * @param {string} [params.name] Name of the file to filter by.
   * @returns {Promise}
   */
  this.getApplicationFiles = (params) => {
    return $q.when(
      webcore.services.files.getApplicationFiles(params)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

  /**
   * Create link to download single application file.
   *
   * A temporary API key provided in the query parameter may be used to forward a link to other part of the app.
   * A temporary API key can be obtained by calling the loginByKey API. It is expired soon after receiving.
   *
   * API_KEY: Required for private files and optional for public files or when the key provided in the query parameter.
   *
   * @param {number} fileId ID of the file to delete.
   * @param [params] Request parameters.
   * @param {string} [params.API_KEY] Temporary file API key.
   * @param {number} [params.userId] User ID to download the file as an administrator.
   * @param {number} [params.locationId] Location ID to download the file as an administrator.
   * @param {boolean} [params.attach] Download the file content as an attachment with the Content-Disposition header.
   *
   * @returns {Promise<string>}
   */
  this.getApplicationFileUrl = (fileId, params) => {
    return $q.when(
      webcore.services.files.getApplicationFileUrl(fileId, params)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

}
